import * as React from "react";
import { useCourseValue } from "context/course.context";
import { useSnackbar } from "notistack";
import { Grid, TextField, Button } from "@material-ui/core";
import CKeditor from "components/CKeditor";
import AWSFileInput from "components/AWSFileInput";
import MUIDateTimePicker from "components/MUIDateTimePicker";

const validateAssignment = (obj: any) => {
  Object.values(obj).forEach((value: any) => {
    if (value === "") return false;
  });
  return true;
};

interface ContentAssignmentFormProps {
  content?: any;
  onCancel: () => void;
  onSubmit: (content: any) => void;
}

const initialData = {
  title: "",
  instruction: "",
  key: "",
  dueDate: new Date().toISOString(),
  submit: null,
} as any;

const ContentAssignmentForm: React.FC<ContentAssignmentFormProps> = ({
  content,
  onCancel,
  onSubmit,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { course } = useCourseValue();
  const [data, setData] = React.useState<any>(content ? content : initialData);
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, title: event.target.value });
  };
  const handleInsChange = (_e: any, editor: any) => {
    setData({ ...data, instruction: editor.getData() });
  };
  const handleKeyChange = (key: string) => {
    setData({ ...data, key });
  };
  const handelDueDateChange = (datetime: Date) => {
    setData({ ...data, dueDate: datetime.toISOString() });
  };
  const handleCancel = () => {
    setData(initialData);
    onCancel();
  };
  const handleSubmit = () => {
    if (validateAssignment(data)) {
      onSubmit(data);
      onCancel();
    } else {
      enqueueSnackbar("You are missing fields.", { variant: "warning" });
    }
  };
  return (
    <Grid container direction="column">
      <Grid item>
        <TextField
          label="Title"
          value={data.title}
          onChange={handleTitleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item>
        <CKeditor
          handleOnChange={handleInsChange}
          data={data.instruction ?? "type here...."}
        />
      </Grid>
      <Grid item>
        <AWSFileInput
          upload={handleKeyChange}
          path={course.student}
          fileKey={data.key}
        />
      </Grid>
      <Grid item>
        <MUIDateTimePicker
          label="Due Time"
          value={data.dueDate}
          onChange={handelDueDateChange}
        />
      </Grid>
      <Grid item>
        <Button color="default" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default ContentAssignmentForm;
